module.exports = __webpack_public_path__ + "img/Navigator.b7c769c0.svg";